<template>
  <div>
    <v-container style="margin-top:-15px">
        <v-row :class="{ 'grey lighten-5' : index % 2 !== 0, 'mb-2 py-2' : true }" :key="category.category" v-for="(category, index) in advancedConfigs">
          <v-col cols="12">
            <h4 style="margin:-10px 0;text-decoration:underline" class="secondary-color">
              <span :id="category.category" class="theme-main-color-darker">
                {{ category.category }}
              </span>
            </h4>
          </v-col>
          <v-col
            style="position:relative"
            :key="advanced.propName"
            v-for="advanced in category.configs"
            cols="12"
            sm="6"
            :id="advanced.propName">
            <v-text-field
              :disabled="fetchConfig"
              v-if="advanced.inputType !== 'select'"
              @change="(val) => updateConfigs(val, advanced.propName)"
              :label="advanced.label || advanced.propName"
              :value="advanced.val"
              filled
              :shaped="false"
            ></v-text-field>
            <v-select
              :disabled="fetchConfig"
              v-if="advanced.inputType === 'select'"
              @change="(val) => updateConfigs(val, advanced.propName)"
              :items="advanced.options"
              filled
              :shaped="false"
              :value="advanced.val"
              :label="advanced.label || advanced.propName"
            ></v-select>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                  <v-icon
                    v-clipboard:copy="advanced.propName"
                    small
                    v-on="on"
                    class="info-icon"
                    style="cursor:copy!important">mdi-information-outline</v-icon>
              </template>
              <span>
                {{ advanced.description || advanced.label || advanced.propName }}. Key: {{ advanced.propName }}
                <span v-if="advanced.fromVersion">.&nbsp;From cashier v.{{ advanced.fromVersion }}</span>
              </span>
            </v-tooltip>
          </v-col>
        </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Advanced-configs',
  props: {
    advancedConfigs: { type: Array, required: true },
    updateConfigs: { type: Function, required: true }
  },
  computed: {
    ...mapState({
      fetchConfig: ({ context }) => context.config.fetchConfig
    })
  }
}
</script>

<style>

</style>
